// South Africa destination — packages DERIVED from the single source
// (data/southafricaSafariData.js, relocated out of the SouthAfrica.js component).
import { safariPackages } from '../southafricaSafariData';
import { canonicalPackage, toNumber } from './adapt';

const packages = safariPackages.map((p) =>
  canonicalPackage({
    id: p.id,
    name: p.title,
    countryName: 'South Africa',
    duration: p.duration,
    priceFrom: toNumber(p.price),
    description: p.bestFor || p.category || '',
    highlights: p.highlights || [],
    regions: p.destinations || [],
    coverImage: p.image,
    rating: p.rating ?? null,
    category: p.category,
    itinerary: p.itinerary,
  })
);

export const southAfricaDestination = {
  key: 'southafrica',
  name: 'South Africa',
  emoji: '🇿🇦',
  tagline: 'Big Five safaris, wine country, and stunning coastal landscapes',
  signature: 'Big Five Game Viewing',
  heroImage:
    'https://images.unsplash.com/photo-1550836990-abdb4b80cca8?w=1920&h=1080&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8c291dGglMjBhZnJpY2ElMjB3aWxkbGlmZXxlbnwwfHwwfHx8MA%3D%3D',
  highlights: ['Cape Town', 'Table Mountain', 'Wine Country', 'Victoria Falls'],
  bestTime: 'March-May (Autumn), September-November (Spring)',
  wildlife: ['Big Five', 'Penguins', 'Marine Life', 'Safari Animals'],
  climate: 'Mediterranean in Cape Town, Subtropical elsewhere',
  currency: 'South African Rand (ZAR)',
  language: 'English, Afrikaans, Zulu, Xhosa',
  mapCenter: [-30.5595, 22.9375],
  mapMarkers: [
    { position: [-24.7972, 31.554], name: 'Kruger National Park' },
    { position: [-33.9249, 18.4241], name: 'Cape Town' },
    { position: [-25.7479, 28.2293], name: 'Johannesburg' },
    { position: [-29.8587, 31.0218], name: 'Durban' },
  ],
  packages,
};
